import { Avatar, Box, Button, Divider, Icon, IconButton, List, Typography } from '@shared/ui';
import type React from 'react';

interface SlackDetailProps {
  back: () => void;
  iconSrc?: string;
}

const SlackDetail: React.FC<SlackDetailProps> = ({ back, iconSrc }) => {
  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <IconButton size="small" onClick={back} aria-label="Back">
          <Icon>arrow_back</Icon>
        </IconButton>
        <Avatar
          variant="rounded"
          sx={{ width: 28, height: 28, ml: 0.5, mr: 1, borderRadius: 6, bgcolor: 'transparent' }}
          src={iconSrc}
        >
          <Icon sx={{ fontSize: 18 }}>chat_bubble</Icon>
        </Avatar>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            Slack
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Manage channels and DMs Moments can access.
          </Typography>
        </Box>
      </Box>
      <Divider sx={{ my: 1 }} />
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Typography variant="caption" sx={{ flex: 1, fontWeight: 600 }}>
          Channels
        </Typography>
        <Button size="small" variant="outlined">
          Add
        </Button>
      </Box>
      <List sx={{ p: 0 }}>
        <Box sx={{ px: 1, py: 0.75 }}>
          <Typography variant="caption" color="text.secondary">
            No channels configured yet.
          </Typography>
        </Box>
      </List>
    </Box>
  );
};

export default SlackDetail;
